import { RequestService } from "../../../../common/services/RequestService";
import { ADD_FOOD_PRODUCT_TO_LIST } from "./constants";

export const addFoodProductToListRequest = async (orderId, payload) => {
  const response = await RequestService.post(
    ADD_FOOD_PRODUCT_TO_LIST.replace("{order_id}", orderId),
    payload
  );

  return response;
};
